/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 1184
// module chunks = 0